module.exports = __webpack_public_path__ + "img/remark.63202026.svg";